import * as React from 'react'

import FormLayout from './layouts/FormLayout'
import GroupedFormLayout from './layouts/GroupedFormLayout'

import useBreakpoint from '@utils/useBreakpoints'

const ControleFormLayout = (props: ControleLayoutProps) => {
  const [, bp] = useBreakpoint()

  return bp === 'phone' ? <GroupedFormLayout {...props} /> : <FormLayout {...props} />
}

export default ControleFormLayout
